export default __webpack_public_path__ + "static/media/logo.919bb983.png";